import { useTranslation } from "@impero-com/common/utils/i18n";
import { emitNotification } from "@impero-com/ui";
import { useQueryClient } from "@tanstack/react-query";

import {
    getGetEntitiesQueryKey,
    usePostEntities,
} from "api/generated/entities/entities";

export function useCreateEntityMutation() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return usePostEntities({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: getGetEntitiesQueryKey(),
                });
            },
            onError: (error) => {
                if (
                    error?.response?.status === 409 &&
                    error.response.data?.code === "LimitReached"
                ) {
                    emitNotification(
                        "error",
                        t("CreateEntity_ControlEntityLimitReached", {
                            limit: error.response.data.limit,
                        })
                    );
                    return;
                }
                emitNotification("error", t("CreateEntity_Submit_ServerError"));
            },
        },
    });
}
